__turbopack_context__.v({
  "productGridItem": "ProductGridItem-module-scss-module__po250q__productGridItem",
  "title": "ProductGridItem-module-scss-module__po250q__title",
});
